import React from 'react';
import {
  Input,
  RadioButton,
  SwitchChangeEvent,
  RadioButtonChangeEvent
} from '@progress/kendo-react-inputs';
import { useToggle } from 'usehooks-ts';
import { Button } from '@progress/kendo-react-buttons';

import { MapLocationDialog } from './map-location-dialog';
import { GameDocumentContext } from '../../contexts/game-document';
import { MapEntity, ResourceEntity } from '../../types/game-document/';

interface MapSettingProps {
  mapInfo?: MapEntity;
  selectedMapOption: string;
  illustrationMapMedia?: ResourceEntity;
  onDeleteIlustrationMap: () => void;
  onSelectIllustrationMapClick: () => void;
  onRecentreLocation: (
    {
      lon,
      lat
    }: {
      lon: number;
      lat: number;
    },
    contentType: 'zones' | 'tasks' | 'areas' | 'all' | 'none' | 'images'
  ) => Promise<void>;
  onSelectedMapChange: (e: RadioButtonChangeEvent) => void;
}

const MapSettings = ({
  selectedMapOption,
  illustrationMapMedia,
  onRecentreLocation,
  onSelectedMapChange,
  onDeleteIlustrationMap,
  onSelectIllustrationMapClick
}: MapSettingProps) => {
  const [state] = React.useContext(GameDocumentContext);

  const [showLocationDialog, toggleLocationDialog] = useToggle(false);

  const selectMapHandler = React.useCallback(() => {
    onSelectIllustrationMapClick();
  }, [onSelectIllustrationMapClick]);

  return (
    <>
      <div className={'d-flex gap-2 align-items-center'}>
        <h5 className={'mt-2'}>Map type</h5>

        <span
          style={{
            fontSize: '12px'
          }}>
          Choose a base map
        </span>
      </div>
      <div className={'d-flex gap-2 flex-column'}>
        <div
          className={'d-flex'}
          style={{
            gap: '24px'
          }}>
          <div className={'fw-bold'}>
            <RadioButton
              name={'map'}
              value={'gis'}
              checked={selectedMapOption === 'gis'}
              label={'GPS'}
              onChange={(e) => onSelectedMapChange(e)}
            />
          </div>
          <div className={'fw-bold'}>
            <RadioButton
              name={'map'}
              value={'illustrated'}
              checked={selectedMapOption === 'illustrated'}
              label={'Illustrated'}
              onChange={(e) => onSelectedMapChange(e)}
            />
          </div>
        </div>

        {selectedMapOption === 'gis' ? (
          <Button
            themeColor={'dark'}
            onClick={toggleLocationDialog}
            style={{
              backgroundColor: '#003A64'
            }}>
            <span className={'material-symbols-outlined'}>
              add_location_alt
            </span>
            <span className={'ml-2'}>Set location</span>
          </Button>
        ) : (
          <div>
            <Button
              className={'w-100'}
              themeColor={'dark'}
              onClick={selectMapHandler}
              style={{
                backgroundColor: '#003A64'
              }}>
              <span className={'material-symbols-outlined'}>image_search</span>
              <span className={'ml-2'}>Select</span>
            </Button>
            {illustrationMapMedia?.id !== '' &&
              illustrationMapMedia?.id !== undefined &&
              illustrationMapMedia?.id !== null && (
                <div className={'my-2 d-flex justify-content-between'}>
                  <span>{illustrationMapMedia!.name}</span>
                  <span
                    className={
                      'material-symbols-outlined ml-3 text-danger cursor-pointer'
                    }
                    onClick={onDeleteIlustrationMap}>
                    delete
                  </span>
                </div>
              )}
          </div>
        )}
      </div>

      {showLocationDialog && (
        <MapLocationDialog
          onClose={toggleLocationDialog}
          onRecentreLocation={onRecentreLocation}
        />
      )}
    </>
  );
};

export default MapSettings;
